<template>
  <div>
    <b-modal
      id="modal-json-viewer"
      title="Visualizar JSON"
      size="lg"
      scrollable
      @hidden="onModalClosed"
    >
      <div class="json-container">
        <pre class="json-content">{{ jsonContent }}</pre>
      </div>
      
      <template #modal-footer>
              <b-button
        variant="primary"
        @click="copyJsonContent"
        class="d-flex align-items-center"
      >
        Copiar
      </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BIcon
} from 'bootstrap-vue';

export default {
  components: {
    BModal,
    BButton,
    BIcon
  },
  name: 'JsonViewerModal',
  
  props: {
    jsonData: {
      type: [String, Object],
      default: null
    }
  },

  data() {
    return {
      jsonContent: ''
    };
  },

  watch: {
    jsonData: {
      handler(newData) {
        this.processJsonData(newData);
      },
      immediate: true
    }
  },

  methods: {
    processJsonData(jsonData) {
      if (!jsonData) {
        this.jsonContent = '';
        return;
      }

      try {
        if (typeof jsonData === 'string') {
          const parsed = JSON.parse(jsonData);
          this.jsonContent = JSON.stringify(parsed, null, 2);
        } else {
          this.jsonContent = JSON.stringify(jsonData, null, 2);
        }
      } catch (error) {
        this.jsonContent = String(jsonData);
      }
    },

    copyJsonContent() {
      try {
        navigator.clipboard.writeText(this.jsonContent).then(() => {
          this.showSuccessToast();
        });
      } catch (error) {
        this.clipboardLegacy();
      }
    },

    clipboardLegacy() {
      const textArea = document.createElement('textarea');
      textArea.value = this.jsonContent;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      this.showSuccessToast();
    },

    showSuccessToast() {
      this.$bvToast.toast('JSON copiado para a área de transferência!', {
        title: 'Sucesso',
        variant: 'success',
        solid: true,
        autoHideDelay: 3000
      });
    },

    onModalClosed() {
      this.jsonContent = '';
      this.$emit('closed');
    },

    show() {
      this.$bvModal.show('modal-json-viewer');
    }
  }
};
</script>

<style scoped>
.json-container {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 1rem;
  max-height: 400px;
  overflow-y: auto;
}

.json-content {
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #495057;
  background: transparent;
  border: none;
  padding: 0;
}
</style>
